import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import Portal from "../Portal";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { projectStorage } from "../../firebase-config/config";
import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
//importing scss
import "./VendorDetailsLeft.scss";
import Select from "react-select";
const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

const VendorDetailsLeft = ({ vendorProfileId }) => {
  const { user } = useAuthContext(); // Current user
  const { updateDocument } = useFirestore("users");

  // change user details
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [userDetails, setUserDetails] = useState({
    fullName: "",
    city: "",
    email: "",
    phoneNumber: "",
    gender: "",
  });
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(true);

  // get and update code start
  // const { document: vendorProfileDoc } = useDocument(
  //   "organisations",
  //   vendorProfileId
  // );

  const { document: vendorProfileDoc } = useDocument(
    "organisations",
    user?.organisationId
  );

  const { documents: organisations } = useCollection("organisations");
  const vendorOrganisations = organisations?.find(
    (org) => org.organisationId === user?.organisationId
  );

  const { updateDocument: updateVendorData } = useFirestore("organisations");

  // START EDIT VENDOR DETAILS
  // useEffect(() => {
  //   if (user) {
  //     setUserDetails({
  //       fullName: user.fullName,
  //       address: user.address,
  //       city: user.city,
  //       email: user.email,
  //       phoneNumber: user.phoneNumber,
  //       gender: user.gender,
  //     });
  //   }
  // }, [user]);

  // const handleEditClick = () => {
  //   setShowEditPopup(true);
  //   setConfirmButtonDisabled(true);
  // };

  // const handleGenderChange = (selectedOption) => {
  //   handleInputChange({
  //     target: { name: "gender", value: selectedOption.value },
  //   });
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setUserDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [name]: value,
  //   }));
  //   setConfirmButtonDisabled(false); // Enable the confirm button when any input changes
  // };

  // const handleCancelClick = () => {
  //   setShowEditPopup(false);
  // };

  // // Confirm update
  // const handleConfirmClick = async () => {
  //   try {
  //     await updateVendorData(vendorProfileId, userDetails);
  //     setShowEditPopup(false);
  //   } catch (error) {
  //     console.error("Error updating user details:", error);
  //   }
  // };
  // END EDIT VENDOR DETAILS

  // START CHANGE IMG CODE START
  const [userData, setUserData] = useState({});
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState();
  const [selectedDummyImage, setSelectedDummyImage] = useState(null);
  const [imgUploading, setImgUploading] = useState(false);

  const defaultImageUrl =
    "https://firebasestorage.googleapis.com/v0/b/propdial-dev-aa266.appspot.com/o/userThumbnails%2F1default.png?alt=media&token=38880453-e642-4fb7-950b-36d81d501fe2";
  const handleImageClick = () => {
    setShowImagePopup(true);
  };

  const handleRemoveImage = () => {
    setImagePreview(defaultImageUrl); // Set to default image URL
    setSelectedImage(null);
    setSelectedDummyImage(null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      setSelectedImage(file);
    }
  };

  const handleCancelImgClick = () => {
    setShowImagePopup(false);
  };

  const handleConfirmImgClick = async () => {
    try {
      if (selectedImage) {
        setImgUploading(true); // Set loader on
        const uploadPath = `vendorBrandLogo/${vendorOrganisations.id}/${selectedImage.name}`;
        const uploadTask = projectStorage.ref(uploadPath).put(selectedImage);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Handle progress
          },
          (error) => {
            console.error("Error uploading file:", error);
            setImgUploading(false); // Set loader off on error
          },
          async () => {
            const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
            await updateVendorData(vendorOrganisations.id, {
              logoURL: downloadURL,
            });
            setImagePreview(downloadURL);
            setSelectedImage(null);
            setImgUploading(false); // Set loader off
            setShowImagePopup(false);
          }
        );
      } else {
        setImgUploading(true);
        await updateVendorData(vendorOrganisations.id, {
          logoURL: defaultImageUrl,
        });
        setImagePreview(defaultImageUrl);
        setImgUploading(false); // Set loader off
        setShowImagePopup(false);
      }
    } catch (error) {
      console.error("Error updating image URL:", error);
      setImgUploading(false); // Set loader off on error
    }
  };
  // END CHANGE IMG CODE START

  return (
    <div className="full-details-left-profile-card animate-slide-in">
      {/* EDIT VENDOR DETAILS START */}
      {/* {showEditPopup && (
        <Portal>
          <div
            className={`business-three-profile-edit-overlay ${
              showEditPopup
                ? "business-three-profile-overlay-open"
                : "business-three-profile-overlay-close"
            }`}
          />
          <div
            className={`business-three-profile-edit-popup ${
              showEditPopup
                ? "business-three-profile-open"
                : "business-three-profile-close"
            }`}
          >
            <div className="business-three-profile-edit-popup-content">
              <div className="business-three-profile-edit-popup-header">
                <h2>Edit Vendor Details</h2>
                <span
                  className="business-three-profile-edit-popup-close"
                  onClick={handleCancelClick}
                >
                  &times;
                </span>
              </div>
              <div className="business-three-profile-edit-popup-body">
                <input
                  type="text"
                  name="fullName"
                  value={userDetails.fullName}
                  onChange={handleInputChange}
                  placeholder="Full Name"
                />
                <Select
                  options={genderOptions}
                  placeholder="Select gender..."
                  isDisabled={false}
                  value={genderOptions.find(
                    (opt) => opt.value === userDetails.gender
                  )}
                  onChange={handleGenderChange}
                />

                <input
                  type="email"
                  name="email"
                  value={userDetails.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                />
              </div>
              <div className="business-three-profile-edit-popup-footer">
                <button
                  onClick={handleConfirmClick}
                  disabled={confirmButtonDisabled}
                  className="btn_fill"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </Portal>
      )} */}
      {/* END EDIT VENDOR DETAILS  */}
      {/* <span
        className="material-symbols-outlined business-three-profile-edit-icon"
        onClick={handleEditClick}
      >
        edit
      </span> */}
      <div className="logo-photo">
        <div className="curved-text-container" style={{ position: "relative" }}>
          <svg viewBox="0 0 200 200" className="curved-svg">
            <defs>
              <path
                id="curvePath"
                d="M 100,190 A 90,90 0 1,1 100,10 A 90,90 0 1,1 100,190"
              />
            </defs>
            <text width="200">
              <textPath href="#curvePath" startOffset="50%" textAnchor="middle">
                BRAND LOGO
              </textPath>
            </text>
          </svg>
          <div className="punch_button pio_done holiday_outer">
            <div className="inner_one">
              <div className="inner_two">
                <h6 className="text-center">
                  <img
                    src={vendorOrganisations && vendorOrganisations.logoURL}
                    alt={`${
                      vendorOrganisations && vendorOrganisations.brandName
                    }'s Logo`}
                  />
                </h6>
              </div>
            </div>
          </div>
          {user &&
            vendorOrganisations &&
            vendorOrganisations.isApproved != true &&
            vendorOrganisations.isActive && (
              <div
                style={{
                  backgroundColor: "#e7e4e4ff",
                  borderRadius: "50%",
                  height: "25px",
                  width: "25px",
                }}
                className="cam-change--indicator d-flex align-items-center justify-content-center"
              >
                <span
                  className="material-symbols-outlined"
                  onClick={handleImageClick}
                >
                  photo_camera
                </span>
              </div>
            )}
        </div>
      </div>
      <div className="profile-info">
        <h2>{vendorOrganisations?.organisationName ?? "Organisation Name"}</h2>
        <div className="contact-info">
          <span>
            {vendorOrganisations?.contactDetail?.primaryPhone
              ? vendorOrganisations.contactDetail.primaryPhone.replace(
                  /(\d{2})(\d{5})(\d{5})/,
                  "+$1 $2-$3"
                )
              : "Primary Phone"}
          </span>
        </div>
        <div className="contact-info">
          <span>
            {vendorOrganisations?.contactDetail?.primaryMail ?? "Primary Email"}
          </span>
        </div>
        <div className="contact-info">
          <span>
            {vendorProfileDoc?.city ?? " "}, {vendorProfileDoc?.country ?? " "}{" "}
          </span>
        </div>
        <div className="contact-methods">
          <Link
            to={`https://wa.me/+${vendorOrganisations?.contactDetail?.primaryPhone}`}
            className="icon right"
            target="_blank"
          >
            <img src="/assets/img/whatsappbig.png" alt="" />
          </Link>
          <Link
            to={`mailto:${vendorOrganisations?.contactDetail?.primaryMail}`}
            className="icon left"
            target="_blank"
          >
            <img src="/assets/img/gmailbig.png" alt="" />
          </Link>
        </div>
        {vendorProfileDoc?.profileLock && (
          <div className="profile-status">
            <span class="material-symbols-outlined">lock</span>
            <p>This profile is Locked</p>
          </div>
        )}
      </div>
      {/* start Image Change Popup */}
      {showImagePopup && (
        <>
          <div
            className={`business-three-profile-edit-overlay ${
              showImagePopup
                ? "business-three-profile-overlay-open"
                : "business-three-profile-overlay-close"
            }`}
          />
          <div
            className={`business-three-profile-edit-popup ${
              showImagePopup
                ? "business-three-profile-open"
                : "business-three-profile-close"
            }`}
          >
            <div className="business-three-profile-edit-popup-header">
              <h2>Brand Logo</h2>
              {!imgUploading && (
                <span
                  className="business-three-profile-edit-popup-close"
                  onClick={handleCancelImgClick}
                >
                  &times;
                </span>
              )}
            </div>
            <div>
              <div className="business-three-profile-popup-body ">
                <div className="business-three-profile-image-preview ">
                  <img
                    src={
                      imagePreview ||
                      (vendorOrganisations && vendorOrganisations.logoURL)
                    }
                    alt="Preview"
                  />
                  {!imgUploading ? (
                    <div>
                      <div className="d-flex justify-content-between">
                        <div style={{ cursor: "pointer" }}>
                          <span
                            className="material-symbols-outlined "
                            onClick={handleRemoveImage}
                          >
                            delete
                          </span>
                        </div>

                        <input
                          type="file"
                          accept="image/*"
                          id="file-input"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <span
                          className="material-symbols-outlined"
                          onClick={() =>
                            document.getElementById("file-input").click()
                          }
                        >
                          folder_open
                        </span>
                      </div>
                      {imagePreview && (
                        <button
                          onClick={handleConfirmImgClick}
                          className="btn_fill"
                        >
                          Confirm
                        </button>
                      )}
                    </div>
                  ) : (
                    <PGLoaders />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* END CHANGE PROFILE IMAGE CODE  */}
    </div>
  );
};

export default VendorDetailsLeft;
